import { Component, inject, OnInit, signal } from '@angular/core';
import { Organization } from "../../fortress/organization.model";
import { CitadelService } from "../../fortress/citadel.service";
import { ActivatedRoute, RouterLink, RouterOutlet } from "@angular/router";

@Component({
  selector: 'app-projects-list',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink
  ],
  templateUrl: './projects-list.component.html',
  styleUrl: './projects-list.component.scss'
})
export class ProjectsListComponent implements OnInit {

  citadel = inject(CitadelService);
  route = inject(ActivatedRoute);

  currentOrganization = this.citadel.currentOrganization;
  organizations = this.citadel.organizations;

  // State signals
  // protected readonly projectsMap = this.projectsService.projectsMap;
  // protected readonly recentProjects = this.projectsService.recentProjects;
  protected readonly showDeleteDialog = signal(false);
  protected readonly orgToDelete = signal<Organization | null>(null);
  protected readonly deleteSummary = signal<any>(null);

  ngOnInit() {
    const children = this.route.snapshot.children;
    if(children.length > 0) {
      this.citadel.setCurrentOrganization(children[0].params['id']);
    }
  }

  // Create a computed signal for each organization's projects
  protected orgProjects(orgId: string) {
    // return computed(() => this.projectsMap()[orgId] || []);
  }

  protected async initiateDelete(orgId: string) {
    // const org = this.organizations().find(o => o.id === orgId);
    // if (org) {
    //   try {
    //     const summary = await this.fortressService.deleteOrganization(org.id, false);
    //     this.orgToDelete.set(org);
    //     this.deleteSummary.set(summary);
    //     this.showDeleteDialog.set(true);
    //   } catch (error) {
    //     console.error('Error getting delete summary:', error);
    //     // Show error dialog
    //     this.dialog.open(ErrorDialogComponent, {
    //       width: '400px',
    //       data: {
    //         title: 'Error',
    //         message: 'Failed to get deletion summary. Please try again.'
    //       }
    //     });
    //   }
    // }
  }

  protected async confirmDelete() {
    // const org = this.orgToDelete();
    // if (!org) return;
    //
    // try {
    //   await this.fortressService.deleteOrganization(org.id, true);
    //
    //   this.cancelDelete();
    // } catch (error) {
    //   console.error('Error deleting organization:', error);
    //   // Show error dialog
    //   this.dialog.open(ErrorDialogComponent, {
    //     width: '400px',
    //     data: {
    //       title: 'Error',
    //       message: 'Failed to delete organization. Please try again.'
    //     }
    //   });
    // }
  }

  protected cancelDelete() {
    this.showDeleteDialog.set(false);
    this.orgToDelete.set(null);
    this.deleteSummary.set(null);
  }

  protected async deleteProject(event: Event, orgId: string, projectId: string) {
    // event.stopPropagation();  // Prevent navigation to project
    //
    // try {
    //   // First get the deletion summary
    //   const summary = await this.projectsService.deleteProject(projectId, false);
    //
    //   // Show confirmation dialog with summary
    //   const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
    //     width: '400px',
    //     data: {
    //       title: 'Delete Project',
    //       summary: summary,
    //       confirmText: 'Delete Project',
    //       type: 'project'
    //     }
    //   });
    //
    //   const confirmed = await dialogRef.afterClosed().toPromise();
    //   if (confirmed) {
    //     // Proceed with deletion
    //     await this.projectsService.deleteProject(projectId, true);
    //   }
    // } catch (error) {
    //   console.error('Error deleting project:', error);
    //   this.dialog.open(ErrorDialogComponent, {
    //     width: '400px',
    //     data: {
    //       title: 'Error',
    //       message: 'Failed to delete project. Please try again.'
    //     }
    //   });
    // }
  }


  protected createProject(orgId: string) {
    // const org = this.organizations().find(o => o.id === orgId);
    // if (!org) return;
    //
    // const dialogRef = this.dialog.open(ProjectCreateDialogComponent, {
    //   width: '500px',
    //   data: {organization: org}
    // });
    //
    // dialogRef.afterClosed().subscribe(async (result) => {
    //   if (result) {
    //     try {
    //       await this.projectsService.createProject(result);
    //     } catch (error) {
    //       console.error('Error creating project:', error);
    //     }
    //   }
    // });
  }
}
